// start:ng42.barrel
import './insurance-container.component';
import './insurance-editor.component';
// end:ng42.barrel

